import { Metamodel } from 'app/model/base/model';
import { Parameter } from '../base/parameter';
import { DataFlowDataType, IDataFlowDataType } from './dataflow-datatype';
import { DataFlowExpression } from './dataflowexpression';
import { IViolation } from '../base/annotation';

import { sanitizeAndFormatString } from 'app/shared/utils/string.util';
import { DataFlowTypesUtils } from './dataflow-type-utilities';
import { IBasedOnEntity } from '../dataset/dataflowcolumn';
import { IValidationContext } from 'shell-models-lib';

@Metamodel.model({
    name: 'dataflowparameter',
    display: ['dataflowparameter', 'dataflowparameters'],
    constraints: {
        defaultValue: {
            validator: DataFlowParameter.prototype.validateDefaultValue
        }
    }
})
export class DataFlowParameter extends Parameter implements IBasedOnEntity {

    public defaultValueExpression: DataFlowExpression;

    public get defaultValue(): string {
        return this.defaultValueExpression ? this.defaultValueExpression.expression : '';
    }

    // @ts-ignore
    public get _type(): DataFlowDataType {
        return this._dataflowType.fullyQualifiedType;
    }

    public set _type(value: DataFlowDataType) {
        this._dataflowType = DataFlowTypesUtils.createType(value);
    }

    public get _dataflowType() {
        return this._typeInternal;
    }

    public set _dataflowType(value: IDataFlowDataType) {
        this._typeInternal = value;
        if (this.defaultValueExpression) {
            this.defaultValueExpression.requiredReturnType = value.typeString;
        }
    }

    private _typeInternal: IDataFlowDataType;

    constructor(name?: string, description?: string, id?: number) {
        super(name, description, id);
    }

    protected async validateDefaultValue(parameter?: DataFlowParameter, defaultValue?: string, violation?: IViolation, context?: IValidationContext): Promise<IViolation[] | undefined> {
        const violations: IViolation[] = [];
        if (parameter && defaultValue) {
            if (!DataFlowTypesUtils.parameterTypeMatch(parameter.defaultValueExpression.returnType, this._type)) {
                violations.push({
                    context: parameter,
                    message: () => sanitizeAndFormatString(stringResources.DataFlow_ParameterTypeValidationError, parameter.name, parameter._type)
                });
            }
        }
        return violations.length <= 0 ? undefined : violations;
    }
}
